import { useState } from "react";
import { Dialog } from "@mui/material";
import AddClubForm from "./AddClubForm";
// import AddUserForm from "./AddUserForm";
// import AxiosInstance from "../Config/AxiosInstance";
// import { ApiList } from "../Config/ApiList";
// Import your AddUserForm component here

const AddClubModal = ({ open, onClose, GetAllClubs }) => {
  // const [clubData, setClubData] = useState(null);
  // const [currentStep, setCurrentStep] = useState(1);

  // Handle the response from AddClubForm - Close modal immediately on success
  const handleClubSuccess = (response) => {
    if (response?.data?.s === 1) {
      // setClubData(response.data?.r);
      // setCurrentStep(2);
      
      // Close modal immediately after successful club creation
      onClose();
      // Refresh the clubs data
      GetAllClubs();
    }
  };

  // Commented out add user functionality
  // const handleUserSuccess = async (response) => {
  //   if (response?.data?.s === 1) {
  //     setUserData(response.data.r);
  //     
  //     try {
  //       const formData = new FormData();
  //       formData.append("club_id", clubData?.club_id);
  //       formData.append("user_id", UserData);
  //   
  //       const res = await AxiosInstance?.post(ApiList?.ADD_USER_TO_CLUB, formData)
  //       if (res?.data?.s === 1) {
  //         onClose();
  //         GetAllClubs() 
  //       }
  //     } catch (error) {
  //       console.log(error)
  //     }
  //   }
  // };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "15px",
          maxHeight: "90vh",
          overflow: "scroll",
        },
      }}
    >
      <AddClubForm onClose={onClose} onSuccess={handleClubSuccess} GetAllClubs={GetAllClubs} />
      
      {/* Commented out step-based form with AddUserForm */}
      {/* {currentStep === 1 ? (
        <AddClubForm onClose={onClose} onSuccess={handleClubSuccess} GetAllClubs={GetAllClubs} />
      ) : (
        <AddUserForm
          clubData={clubData}
          GetAllClubs={GetAllClubs}
          onClose={onClose}
          setCurrentStep={setCurrentStep}
        />
      )} */}
    </Dialog>
  );
};

export default AddClubModal;
